module.exports = __webpack_public_path__ + "static/media/ios-thumbs-down.b47e5d01.svg";